<!--
 * @Author: WGL 958897276@qq.com
 * @Date: 2025-05-23 14:48:46
 * @LastEditors: WGL 958897276@qq.com
 * @LastEditTime: 2025-05-28 10:51:28
 * @FilePath: /erp-admin/src/components/StagePipelineItem/index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="stage-pipeline-item-content">
    <div
      class="bor stage-pipeline-item-wrapper fxmj"
      :class="[
        isEdit ? 'stage-pipeline-item-edit' : '',
        index || groupIndex ? '' : 'stage-pipeline-item-wrapper-first',
        hasGroup && !index ? 'stage-pipeline-item-wrapper-first-group' : '',
      ]"
    >
      <el-popover
        :disabled="!isEdit"
        :persistent="false"
        placement="right"
        title="优先级"
        trigger="click"
        :width="240"
      >
        <template #reference>
          <div
            class="stage-pipeline-item-wrapper-stage"
            :style="{
              backgroundColor: isComplete
                ? '#67C23A'
                : PRIORITY_COLOR2[item.priority],
            }"
            :title="priorityTextTips"
          >
            <jwt-icon v-if="isComplete" icon="check-fill" size="22" />
            <span v-else>{{ index + 1 }}-{{ groupIndex + 1 }}</span>
          </div>
        </template>
        <el-radio-group
          v-if="isEdit"
          v-model="priorityRadio"
          @change="handleChangePriority"
        >
          <el-radio v-for="(val, key) in PRIORITY" :key="key" :value="+key">
            {{ val }}
          </el-radio>
        </el-radio-group>
      </el-popover>

      <div v-if="isEdit" class="ex omit plr4">
        <input
          v-model="item.title"
          placeholder="请输入内容"
          style="height: 30px; max-width: 140px"
        />
      </div>
      <div v-else class="ex omit plr4" :title="item.title">
        <slot name="title" :row="item">
          {{ item.title }}
        </slot>
      </div>
      <!-- 添加 -->
      <div
        v-if="!isGroup"
        class="stage-pipeline-item-add-right"
        @click="handleAddPipeline('right')"
      >
        <div class="fxmc wh18">
          <jwt-icon icon="add-large-line" size="12" />
        </div>
      </div>
      <!-- 添加 -->
      <div
        v-if="!isGroup"
        class="stage-pipeline-item-add-bottom"
        @click="handleAddPipeline('bottom')"
      >
        <div class="fxmc wh18">
          <jwt-icon icon="add-large-line" size="12" />
        </div>
      </div>
      <!-- 删除 -->
      <div
        class="stage-pipeline-item-add-delete"
        @click="handleAddPipeline('delete')"
      >
        <div class="fxmc wh18">
          <jwt-icon icon="close-circle-fill" size="22" />
        </div>
      </div>
    </div>
    <div
      v-if="hasGroup"
      class="stage-pipeline-item-group-wrapper"
      :class="[isLast ? 'stage-pipeline-item-group-wrapper-last' : '']"
    >
      <VueDraggable
        v-model="item.groupList"
        animation="150"
        :disabled="!isEdit"
        ghost-class="ghost"
      >
        <StagePipelineItem
          v-for="(group, i) in item.groupList"
          :key="i"
          :group-index="i + 1"
          :index="index"
          :is-edit="isEdit"
          :is-group="hasGroup"
          :is-instance="isInstance"
          :item="group"
          @add-pipeline="handleGroupAddPipeline"
          @change-priority="handleChangeGroupPriority"
        >
          <template #title="{ row }">
            <slot name="title" :row="row"></slot>
          </template>
        </StagePipelineItem>
      </VueDraggable>
    </div>
  </div>
</template>

<script setup>
  import { defineProps, computed, defineEmits, ref } from 'vue'
  import { isArray } from 'lodash-es'
  import { VueDraggable } from 'vue-draggable-plus'
  import { PRIORITY_COLOR2, PRIORITY } from '@/config/variable.config.js'

  const props = defineProps({
    item: { type: Array, default: () => [] },
    isGroup: { type: Boolean, default: false },
    isEdit: { type: Boolean, default: true },
    index: { type: Number, default: 0 },
    groupIndex: { type: Number, default: 0 },
    len: { type: Number, default: 0 },
    isInstance: { type: Boolean, default: false }, // 是否是流程实例
  })
  const emit = defineEmits(['add-pipeline', 'change-priority'])
  const priorityRadio = ref(1)
  // 是否分组
  const hasGroup = computed(() => {
    return isArray(props?.item?.groupList) && props?.item?.groupList.length > 0
  })
  // 是否最后一条
  const isLast = computed(() => {
    return props.index === props.len - 1
  })
  // 优先级文案提示
  const priorityTextTips = computed(() => {
    return `优先级：${PRIORITY[props.item.priority]}`
  })
  // 是否完成
  const isComplete = computed(() => {
    return props?.item?.status === 10 && props.isInstance && !props.isEdit
  })
  /**
   * 数据添加删除
   * @param type
   */
  function handleAddPipeline(type = 'add') {
    emit(
      'add-pipeline',
      type,
      props.item,
      props.groupIndex ? props.groupIndex : props.index
    )
  }

  function handleGroupAddPipeline(type, item, index) {
    emit('add-pipeline', type, item, index, props.index)
  }

  // 改变优先级
  function handleChangePriority(val) {
    console.log('val :>> ', val)
    emit(
      'change-priority',
      val,
      props.groupIndex ? props.groupIndex : props.index
    )
  }

  function handleChangeGroupPriority(val, index) {
    emit('change-priority', val, index, props.index)
  }
</script>

<style lang="scss" scoped>
  $spacing: 40px;
  $height: 45px;
  $line-color: #b8c0cb;
  .stage-pipeline-item {
    &-wrapper {
      position: relative;
      width: 200px;
      height: $height;
      line-height: $height;
      margin: $spacing / 2 $spacing;
      border-radius: 4px;
      &::after {
        content: '';
        position: absolute;
        width: $spacing * 2;
        height: 1px;
        top: 50%;
        left: -$spacing * 2;
        transform: translatY(-50%);
        background-color: $line-color;
      }
      &::before {
        content: '';
        width: 0;
        height: 0;
        border-top: 5px solid transparent;
        border-bottom: 5px solid transparent;
        position: absolute;
        left: -5px;
        top: ($height / 2) - 5px;
        border-left: 5px solid $line-color;
        z-index: 1;
      }
      &-first {
        &::after {
          display: none;
        }
        &::before {
          display: none;
        }
        &-group {
          &::after {
            display: block;
            left: -$spacing / 2;
            width: $spacing / 2;
          }
        }
      }
      &-stage {
        width: 40px;
        height: 43px;
        text-align: center;
        color: #fff;
        background-color: var(--el-color-primary);
        border-radius: 4px 0 0 4px;
      }
    }

    &-add-right,
    &-add-bottom,
    &-add-delete {
      display: none;
      position: absolute;
      // width: 20px;
      // height: 20px;
      border-radius: 30px;
      border: 1px solid $line-color;
      background-color: #fff;
      z-index: 1;
      &:hover {
        background-color: var(--el-color-primary);
        color: #fff;
      }
    }
    &-add-right {
      right: -10px;
    }
    &-add-bottom {
      bottom: -10px;
      left: 50%;
      transform: translateX(-50%);
    }
    &-add-delete {
      top: -15px;
      right: -10px;
      border: none;
      background-color: #fff;
      color: var(--el-color-danger);
      &:hover {
        background-color: #fff;
        color: var(--el-color-danger);
      }
    }
    &-group-wrapper {
      .stage-pipeline-item-wrapper {
        &::after {
          content: '';
          position: absolute;
          width: $spacing / 2;
          height: 1px;
          top: 50%;
          left: -$spacing / 2;
          transform: translatY(-50%);
        }
      }
      .stage-pipeline-item-content {
        position: relative;
        &::before {
          content: '';
          position: absolute;
          left: ($spacing / 2);
          bottom: ($height / 2);
          height: ($spacing / 2) + $height;
          width: 1px;
          background-color: $line-color;
        }
        &::after {
          content: '';
          position: absolute;
          right: ($spacing / 2);
          bottom: ($height / 2);
          width: ($spacing / 2);
          height: ($spacing / 2) + $height;
          border: 1px solid $line-color;
          border-left: none;
          border-top: none;
        }
      }
      &-last {
        .stage-pipeline-item-content {
          &:first-child {
            &::after {
              border-top: 1px solid $line-color;
            }
          }
        }
      }
    }
    &-edit {
      &:hover {
        border-color: var(--el-color-primary);
        cursor: pointer;
        .stage-pipeline-item-add-right,
        .stage-pipeline-item-add-bottom,
        .stage-pipeline-item-add-delete {
          display: block;
        }
      }
      &::after {
        background-color: var(--el-color-primary);
      }
      &::before {
        border-left-color: var(--el-color-primary);
      }
      & + .stage-pipeline-item-group-wrapper {
        .stage-pipeline-item-content {
          &::before {
            background-color: var(--el-color-primary);
          }
          &::after {
            border: 1px solid var(--el-color-primary);
            border-left: none;
            border-top: none;
          }
          .stage-pipeline-item-wrapper-stage {
            cursor: move;
          }
        }
      }
      & + .stage-pipeline-item-group-wrapper-last {
        .stage-pipeline-item-content {
          &:first-child {
            &::after {
              border-top: 1px solid var(--el-color-primary);
            }
          }
        }
      }
    }
  }
</style>
